<template>
    <div class="component">
        <div class="registration-form">
            
                <div class="form-icon">
                    <span>
                        <img src="/img/contractlogo.png" alt="" width="100px">
                    </span>
                </div>
                <div>
                    <h2><b>Contract</b> - I BRAND BD</h2>
                </div>

            <form action="https://formspree.io/f/xbjnjlol" method="POST">
                <div class="form-group">
                    <input name="Name" type="text" class="form-control item" id="username" placeholder="Full Name">
                </div>
                <div class="form-group">
                    <input name="Address" type="address" class="form-control item" id="password" placeholder="Address">
                </div>
                <div class="form-group">
                    <input name="Email" type="email" class="form-control item" id="email" placeholder="Email">
                </div>
                <div class="form-group">
                    <input name="Number" type="phone" class="form-control item" id="phone-number" placeholder="Phone Number">
                </div>
                <div class="form-group">
                    <textarea name="Message" class="form-control item" id="birth-date" cols="60" rows="6" placeholder="Submit Your Message"></textarea>
                </div>
                <div class="form-group">
                    <button style="background-color: #060606;" type="submit" value="send" class="btn btn-block create-account">SUBMIT  ➥</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContractCompo',
        

    }
    
</script>

<style scoped>
.registration-form{
	padding: 50px 0;
}

.registration-form form{
    background-color: #fff;
    max-width: 600px;
    margin: auto;
    padding: 50px 70px;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.075);
}

.registration-form .form-icon{
	text-align: center;
    background-color: #060606;
    border-radius: 50%;
    font-size: 40px;
    color: white;
    width: 100px;
    height: 100px;
    margin: auto;
    margin-bottom: 50px;
    line-height: 100px;
}

.registration-form .item{
    margin-bottom: 25px;
    padding: 10px 20px;
}

.registration-form .create-account{
    padding: 10px 20px;
    font-size: 14px;
    font-weight: bold;
    background-color: #060606;
    border: none;
    color: white;
    margin-top: 20px;
    width: 100%;
}

.registration-form .create-account:hover{
    background: #303030;
}

.registration-form .social-media{
    max-width: 600px;
    background-color: #fff;
    margin: auto;
    padding: 35px 0;
    text-align: center;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    color: #aeaeae;
    border-top: 1px solid #dee9ff;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.075);
}

.registration-form .social-icons{
    margin-top: 30px;
    margin-bottom: 16px;
}

.registration-form .social-icons a{
    font-size: 23px;
    margin: 0 3px;
    color: #060606;
    border: 1px solid;
    border-radius: 50%;
    width: 45px;
    display: inline-block;
    height: 45px;
    text-align: center;
    background-color: #fff;
    line-height: 45px;
}

.registration-form .social-icons a:hover{
    text-decoration: none;
    opacity: 0.6;
}
.btn:hover{
    color: #fff;
}
span img{
    margin-top: -20px;
}
.form-control::placeholder{
    opacity: 0.8;
}

@media (max-width: 576px) {
    .registration-form form{
        padding: 50px 20px;
    }

    .registration-form .form-icon{
        width: 70px;
        height: 70px;
        font-size: 30px;
        line-height: 70px;
    }
    span img{
    width: 65px;
    margin-top: -15px;
}
}
</style>